export const NONE = 0
export const RELIABLE = 1
export const UNRELIABLE = 2
export const WITHRESERVATIONS = 3
